var _path, _path2, _path3, _path4, _rect, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationEtudeSection1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 566,
    height: 484,
    viewBox: "0 0 566 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.568 404.404C280.568 436.594 254.473 462.689 222.284 462.689C190.094 462.689 163.999 436.594 163.999 404.404L163.999 123.013C163.999 90.8233 190.094 64.7285 222.284 64.7285C254.473 64.7285 280.568 90.8232 280.568 123.013V404.404Z",
    fill: "#E29578"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M449.999 362.5C449.999 398.675 420.674 428 384.499 428C348.325 428 318.999 398.675 318.999 362.5V65.5C318.999 29.3253 348.325 0 384.499 0C420.674 0 449.999 29.3253 449.999 65.5V362.5Z",
    fill: "#679ACB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M337 390.5C337 413.972 317.972 433 294.5 433C271.028 433 252 413.972 252 390.5L252 126.5C252 103.028 271.028 84 294.5 84C317.972 84 337 103.028 337 126.5V390.5Z",
    fill: "#FFDDD2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M381 377C381 395.778 365.778 411 347 411C328.222 411 313 395.778 313 377V179C313 160.222 328.222 145 347 145C365.778 145 381 160.222 381 179V377Z",
    fill: "#E8F8FE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 842.319,
    y: 332.874,
    width: 144.436,
    height: 842,
    rx: 72.218,
    transform: "rotate(90.1275 842.319 332.874)",
    fill: "#005B7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M305 484C278.49 484 257 462.51 257 436C257 409.49 278.49 388 305 388L585 388C611.51 388 633 409.49 633 436C633 462.51 611.51 484 585 484L305 484Z",
    fill: "#679ACB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEtudeSection1);
export default __webpack_public_path__ + "static/media/IllustrationETUDE_Section1.261d682873f782055e5c9c6f7c9498c5.svg";
export { ForwardRef as ReactComponent };